import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/throw';


export class NotificationService {
	public emitEventActionSource = new Subject <any>();
	public emitEventAction$ = this.emitEventActionSource.asObservable();

	public emitEventAction(dataToEmit: any): void {
		this.emitEventActionSource.next(dataToEmit);
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/notification/notification.service.ts